import { render, staticRenderFns } from "./ApprovalResult.vue?vue&type=template&id=04ddbb06"
import script from "./ApprovalResult.vue?vue&type=script&lang=ts"
export * from "./ApprovalResult.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports